import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { Alert } from '../../shared/alert/alert';
import { Card } from '../../shared/card/card';
import { MeatballsMenu } from '../../shared/meatballs-menu/meatballs-menu';
import { getPaymentsErrorCode } from '../../../utils/payments';
import { CardType } from '../../../constants/payments';
import { pushErrorEvent } from '../../../utils/analytics';
import { IMAGES_ASSETS_URL } from '../../../constants/links';
import { CHANGES_SAVED_MSG } from '../../../constants/response-success-messages';
import { ERR_UNABLE_TO_SAVE } from '../../../constants/response-error-messages';
import { useMeatballMenuActions } from '../../../hooks/use-meatball-payment-actions';
import { usePayments } from '../../../hooks/use-payments';
export const ProXtraDollarCard = ({ card, onActionSuccess, onActionFailure, }) => {
    var _a, _b;
    const { proXtraDollarCards } = usePayments();
    const { onViewPurchases, onEditNickName } = useMeatballMenuActions();
    const isExpired = (date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return date ? new Date(date) < today : false;
    };
    const handleEditNickName = () => {
        const currentProXtraCard = (proXtraDollarCards === null || proXtraDollarCards === void 0 ? void 0 : proXtraDollarCards.response).find((payment) => payment.paymentId === card.paymentId);
        const onSuccess = () => {
            onActionSuccess(card.paymentId, CHANGES_SAVED_MSG.message);
        };
        const onFailure = (error) => {
            const errorCode = getPaymentsErrorCode(error);
            onActionFailure(card.paymentId, ERR_UNABLE_TO_SAVE.message);
            pushErrorEvent('edit proxtra dollars card', 'inline', errorCode || 'n/a', ERR_UNABLE_TO_SAVE.message);
        };
        onEditNickName(card, currentProXtraCard, CardType.PRO_XTRA_DOLLARS, onSuccess, onFailure);
    };
    const b2bMenuItems = [
        {
            value: 'Edit Nickname',
            action: handleEditNickName,
            isHidden: !((_a = card.actions) === null || _a === void 0 ? void 0 : _a.edit),
        },
        {
            value: 'View Purchases',
            action: () => {
                onViewPurchases(card, CardType.PRO_XTRA_DOLLARS);
            },
            isHidden: !((_b = card.actions) === null || _b === void 0 ? void 0 : _b.viewPurchases),
        },
    ];
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { isDefault: card.isDefault, defaultLabel: "Default Payment Method" },
            React.createElement("div", { className: `sui-flex sui-justify-between sui-align-center ${card.cardNickName ? 'sui-mb-2' : 'sui-mb-3'}` },
                React.createElement("h3", { className: "sui-font-display sui-text-3xl sui-mr-4" }, card.cardNickName),
                React.createElement("div", null,
                    React.createElement(MeatballsMenu, { label: "Payment", items: b2bMenuItems }))),
            React.createElement("div", { className: "sui-flex sui-mb-6" },
                React.createElement("img", { width: 40, height: "auto", className: "sui-inline-block sui-mr-4", src: `${IMAGES_ASSETS_URL}/pro-xtra-rewards.png`, alt: "ProXtra card logo" }),
                React.createElement("div", { className: "sui-mr-4" },
                    React.createElement(Typography, { variant: "body-lg", color: "subtle" },
                        "-",
                        card.cardNumberLast4,
                        "-")),
                card.rewardExpDate && (React.createElement(Typography, { variant: "body-lg", color: "subtle" }, `Exp ${card.rewardExpDate}`))),
            isExpired(card.rewardExpDate) && React.createElement(Alert, { status: "error" }, "Expired"),
            card.gcBalance && (React.createElement(Typography, { variant: "body-lg", weight: "bold", color: "primary" },
                "Balance $",
                card.gcBalance)),
            card.rewardStartDate && (React.createElement(Typography, { variant: "body-lg", color: "primary" },
                "Earned Date ",
                card.rewardStartDate)))));
};
ProXtraDollarCard.displayName = 'ProXtraDollarCard';
